import React, {useState} from 'react'
import { Container, Form, Button, FloatingLabel, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

export default function ProfileEditForm(props) {
    const [newProfile, setNewProfile] = useState(props.profile)

    let navigate = useNavigate();

    const handleChange = (event) => {
        const attributeToChange = event.target.name
        const newValue = event.target.value
    
        const profile = {...newProfile}
        profile[attributeToChange] = newValue
        // console.log(profile)
        setNewProfile(profile)
    }
    
    const editProfile = (profile) => {
        Axios.put("profile/update", profile, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
        .then(response => {
            props.handleSuccessMessage("Profile Updated on the database.")
        })
        .catch(error => {
            props.handleErrorMessage("Error Editing Profile")
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        editProfile(newProfile);
        event.target.reset();
        props.onHide();
    }
    
    
      return (
        <div>

            <Container>
                <Form onSubmit={handleSubmit}>
                    <Col xs={12} sm={8} className="center-form">
                        <FloatingLabel controlId="floatingInput" label="First Name" className="mb-3">
                            <Form.Control type="text" name="firstName" placeholder="First Name" onChange={handleChange} value={newProfile.firstName}></Form.Control>
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingInput" label="Last Name" className="mb-3">
                            <Form.Control type="text" name="lastName" placeholder="Last Name" onChange={handleChange} value={newProfile.lastName}></Form.Control>
                        </FloatingLabel>
                        <FloatingLabel controlId="floatingInput" label="Email Address" className="mb-3">
                            <Form.Control type="email" name="emailAddress" placeholder="name@example.com" onChange={handleChange} value={newProfile.emailAddress}></Form.Control>
                        </FloatingLabel>
                        <Button variant="dark" type="submit" value="Update Profile">Save</Button>
                    </Col>
                </Form>
            </Container>

        </div>
      )
}
